<div class="imgcontainer mat-elevation-z4" style="background-color: lightgray;">
    <img [src]="imgURL" id="editing-image"
        onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
        [attr.x-contenttype]="'image/png'">
</div>
<div *ngIf="displayButtons" class="md-form mb-3">
    <div style=" display: inline-block; display: flex; text-align: left">
        <input #fileInput id="file-upload" type="file" (change)="imgChange($event)"
            style="padding:1em;width: 100%;min-height: 50px;display: none;" />
        <span *ngIf="enablePicture" class="app-icon app-icon--image"><mat-icon (click)="fileInput.click()"
                title="Select Image">image</mat-icon></span>
        <span *ngIf="enableCamera" class="app-icon app-icon--camera"><mat-icon (click)="cameraClick()" title="Take Picture" /></span>
        <!-- <span class="app-icon app-icon--save"><mat-icon *ngIf="newImage" (click)="saveclick()" title="Save Changes" /></span> -->
        <span *ngIf="enableDelete" class="app-icon app-icon--delete"><mat-icon (click)="deleteClick()" title="Delete Image" /></span>
    </div>
</div>